import { HomePageRequestedReviewsCard } from '@roadiehq/backstage-plugin-github-pull-requests';
import type { CreateCardHomePageWidget } from './Home';

const RequestedReviewsWidget = () => (
  <HomePageRequestedReviewsCard hostname="schibsted.ghe.com" />
);

export const createRequestedReviewsWidget = (
  createCardHomePageWidget: CreateCardHomePageWidget,
) =>
  createCardHomePageWidget({
    extensionId: 'backstage-plugin-requested-reviews',
    widgetName: 'RequestedReviews',
    title: 'Requested Reviews',
    description: 'Your requested reviews across all repositories',
    Component: RequestedReviewsWidget,
  });
